module.exports = __webpack_public_path__ + "static/media/filter.f985139e.svg";